import { Avatar, List } from 'antd'
import { useContext } from 'react'
import TenantsContext from './TenantsContext'
import { TenantForSidebarDto } from './tenantsModel'

type Props = {
  listData: TenantForSidebarDto[]
  onTenantSelect: (tenantId: number) => void
  publicBucketName: string
}

const TenantsSidebarList = ({ listData, onTenantSelect, publicBucketName }: Props) => {
  const { state: { tenant: selectedTenant } } = useContext(TenantsContext)

  return <List
    dataSource={listData}
    rowKey={(tenant) => tenant.id}
    renderItem={(tenant) => (
      <List.Item
        style={{
          cursor: 'pointer',
          backgroundColor: selectedTenant.id === tenant.id ? '#4a6b9a' : undefined,
          padding: '10px 10px'
        }}
        onClick={() => onTenantSelect(tenant.id)}
      >
        <List.Item.Meta
          avatar={<Avatar src={`https://${publicBucketName}.s3.amazonaws.com/${tenant.path}/images/logo.png`} size={52} />}
          title={tenant.name}
        />
      </List.Item>
    )}
  />
}

export default TenantsSidebarList